(()=>{
  const ready=fn=>document.readyState==='loading'?document.addEventListener('DOMContentLoaded',fn,{once:true}):fn();
  const STORAGE_KEY='klaxon_welcome_v3_dismissed_at';
  const DISMISS_FOR=6*60*60*1000;

  ready(()=>{
    const popup=document.querySelector('[data-klx-engagement-popup]');
    if(!popup)return;

    const params=new URLSearchParams(window.location.search);
    const themeIsPreview=Boolean(window.Shopify&&window.Shopify.theme&&window.Shopify.theme.role&&window.Shopify.theme.role!=='main');
    const isPreview=Boolean((window.Shopify&&window.Shopify.designMode)||themeIsPreview||params.has('preview_theme_id'));
    const force=params.get('klaxon_popup')==='1';

    const prepare=()=>{
      popup.dataset.klxLaunchPopup='true';
      const eyebrow=popup.querySelector('.klx-eyebrow');
      const title=popup.querySelector('#klx-popup-title');
      const intro=title?title.nextElementSibling:null;
      const chips=popup.querySelector('.klx-engagement__chips');
      const content=popup.querySelector('.klx-engagement__content');
      const closeBtn=popup.querySelector('[data-klx-popup-close]');
      const skip=popup.querySelector('.klx-engagement__skip');

      if(eyebrow)eyebrow.textContent='WELCOME TO KLAXON';
      if(title)title.textContent='Furniture for Modern Indian Homes';
      if(intro&&intro.tagName==='P')intro.textContent='Explore practical KLAXON furniture for study, dining, bedrooms, storage and everyday living.';
      if(chips)chips.innerHTML='<span class="klx-engagement__chip">Modern furniture</span><span class="klx-engagement__chip">Buying guidance</span><span class="klx-engagement__chip">Customer support</span>';
      if(closeBtn){closeBtn.setAttribute('aria-label','Close welcome popup');closeBtn.setAttribute('title','Close');}

      popup.querySelectorAll('.klx-popup-form,.klx-engagement__actions,.klx-popup-actions').forEach(el=>el.remove());
      if(content){
        const actions=document.createElement('div');
        actions.className='klx-popup-actions';
        actions.innerHTML='<a class="klx-btn klx-btn--primary" href="/collections/all-klaxon-furniture">Explore Collection</a><a class="klx-btn klx-btn--outline" href="#klx-rooms">Shop by Room</a>';
        if(skip)content.insertBefore(actions,skip);else content.appendChild(actions);
      }
      if(skip)skip.textContent='Close anytime.';
    };

    prepare();

    let dismissedAt=0;
    try{dismissedAt=Number(localStorage.getItem(STORAGE_KEY)||0);}catch(e){}
    if(!force&&!isPreview&&dismissedAt&&Date.now()-dismissedAt<DISMISS_FOR)return;

    const panel=popup.querySelector('.klx-engagement__panel');
    const closeBtn=popup.querySelector('[data-klx-popup-close]');
    let lastFocus=null;
    let open=false;
    let eligible=false;
    let delayTimer=0;
    let retryTimer=0;

    const rememberDismissal=()=>{if(isPreview||force)return;try{localStorage.setItem(STORAGE_KEY,String(Date.now()));}catch(e){}};
    const blocked=()=>document.querySelector('.klx-header.is-menu-open,.klx-quick-modal.is-open,.klx-video-modal:not([hidden]),#quickView[style*="display: block"],.modal-wrap.fancybox-content,[data-cart-drawer][aria-hidden="false"],.cart-drawer.is-open');

    const show=()=>{
      if(open)return;
      if(blocked()){
        window.clearTimeout(retryTimer);
        retryTimer=window.setTimeout(show,900);
        return;
      }
      open=true;
      lastFocus=document.activeElement;
      popup.hidden=false;
      popup.removeAttribute('aria-hidden');
      document.body.classList.add('klx-popup-open');
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        popup.classList.add('is-open');
        window.setTimeout(()=>closeBtn&&closeBtn.focus({preventScroll:true}),80);
      }));
      window.removeEventListener('scroll',onScroll);
    };

    const hide=(remember=true)=>{
      window.clearTimeout(delayTimer);
      window.clearTimeout(retryTimer);
      if(remember)rememberDismissal();
      if(!open){popup.hidden=true;popup.setAttribute('aria-hidden','true');return;}
      open=false;
      popup.classList.remove('is-open');
      document.body.classList.remove('klx-popup-open');
      window.setTimeout(()=>{if(!open){popup.hidden=true;popup.setAttribute('aria-hidden','true');}},260);
      if(lastFocus&&typeof lastFocus.focus==='function')window.setTimeout(()=>lastFocus.focus({preventScroll:true}),280);
    };

    const onScroll=()=>{
      if(!eligible||open)return;
      if(window.scrollY>Math.max(260,window.innerHeight*.45))show();
    };

    window.setTimeout(()=>{eligible=true;},isPreview||force?300:1600);
    delayTimer=window.setTimeout(()=>{eligible=true;show();},force?450:(isPreview?1200:4500));
    window.addEventListener('scroll',onScroll,{passive:true});

    if(closeBtn)closeBtn.addEventListener('click',()=>hide(true));
    popup.addEventListener('pointerdown',event=>{if(event.target===popup)hide(true);});
    popup.addEventListener('click',event=>{
      const link=event.target.closest('.klx-popup-actions a');
      if(!link)return;
      rememberDismissal();
      document.body.classList.remove('klx-popup-open');
    });
    document.addEventListener('keydown',event=>{
      if(!open)return;
      if(event.key==='Escape'){event.preventDefault();hide(true);return;}
      if(event.key==='Tab'&&panel){
        const focusable=[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>el.offsetParent!==null);
        if(!focusable.length)return;
        const first=focusable[0],last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
  });
})();
